import { Component, Inject, OnDestroy, OnInit, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormGroupDirective, NgForm, ValidatorFn, ValidationErrors, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JfseService, LigneOrganisme, ListeDICO, ListeSituation } from 'src/app/services/jfse/jfse.service';
import { REGEX_NAME, StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { FseIo } from 'src/app/utils/interfaces/new/FseIo.interface';
import { Observable, Subscription, of, from } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, tap, filter, map } from 'rxjs/operators';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { PatientService } from 'src/app/services/patient/patient.service';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { PatientVitale } from 'src/app/utils/interfaces/new/patientVitale';
import { FiltrePatient } from 'src/app/utils/interfaces/new/filtre-patient.interface';


/** Gère l'affichage des erreurs sur le formulaire */
class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

/** Validateur personnalisé : Si un champ de "assuré" est rempli, ils doivent tous être remplis */
// const assureFieldsValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
//   if (!(group instanceof FormGroup)) return null;

//   const fields = ['nom_assure', 'prenom_assure', 'date_assure', 'rang_assure'];
//   const values = fields.map(field => group.get(field)?.value);

//   const anyFilled = values.some(value => !!value); // Vérifie si au moins un champ est rempli
//   const allFilled = values.every(value => !!value); // Vérifie si tous sont remplis

//   return anyFilled && !allFilled ? { assureIncomplete: true } : null;
// };

@Component({
  selector: 'app-choix-patient-degrade',
  templateUrl: './choix-patient-degrade.component.html',
  styleUrls: ['./choix-patient-degrade.component.scss']
})

export class ChoixPatientDegradeComponent implements OnInit, OnDestroy {

  @ViewChild(MatAutocompleteTrigger) autoTrigger!: MatAutocompleteTrigger;
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  public searchCtrl = new FormControl('');
  public nirAssure: string = "";
  public cle: number | null = null;
  public nirInvalide: boolean = false;
  public PatDegradeForm: FormGroup | null = null;
  public ControlOrganismes = new FormControl();
  public errorMessage = '';
  public isError = false;
  private subscription: Subscription = new Subscription();
  private filteredOrganismes: Observable<LigneOrganisme[]>;
  public qualites = [];
  public codegestions = [];
  public filteredCodeGestions = []; // Liste des options filtrées
  public ListeCodeSituation = []; // Liste des situations
  public ListeOrganismes: LigneOrganisme[]; // Liste des caisse et centre
  public regimes = [];
  public title: string = '';
  public dateNaissBenef: string = 'Date de naissance *';
  public SearchidPatient: string | null = null;
  public SearchPatientNom: string | null = null;
  private SearchDonneeAMCPatient: any = undefined;
  public loading = false;

  public patientsList: any[]=[];
  private recentPatients: any[]=[];
  private FiltredPatient: FiltrePatient;
  private getPatientVu = true;
  public patientVu = false;
  matcher = new MyErrorStateMatcher();

  constructor(
    @Inject(MAT_DIALOG_DATA) public PatientDegrade: any,
    private dialogRef: MatDialogRef<ChoixPatientDegradeComponent>,
    private _JFSEsrv: JfseService,
    private _formBuilder: FormBuilder,
    private _strUtilsSrv: StringUtilsService,
    private _snackbarSrv: SnackbarService,
    private modalsrv: ModalService,
    private viewContainerRef: ViewContainerRef,
    private patientSrv: PatientService
  ) {
  }
  displayPatient = (p: any) => p ? `${p.nomPrenomDateNaissance}` : '';

  ngOnInit(): void {
    if(this.PatientDegrade.mode === 'SSV') {
    this.title = 'Mode Sesam Sans Vitale';
    } else {
      this.title = 'Mode Dégradé';
    }

    this.chargerListes();
    this.initialiserForm();

    // Écouter les changements de `regime_benef` et filtrer la liste
    const sub1 = this.PatDegradeForm.get('codeRegime')?.valueChanges.subscribe(value => {
      this.filterCodeGestions(value);
      this._JFSEsrv.getListeSituations(value).then((data: ListeSituation[]) => {
        this.ListeCodeSituation = data;
        // console.log('ListeSituation',this.ListeCodeSituation);
      }
      );
      this._JFSEsrv.getListeOrganismes(value).then((data: LigneOrganisme[]) => {
        this.ListeOrganismes = data;
        // console.log('ListeOrganismes',this.ListeOrganismes);
      }
      );
    });
    const sub2 = this.ControlOrganismes.valueChanges.subscribe(value => {
      this.onSelectedOrganisme(value);
    });

    this.subscription.add(sub1);
    this.subscription.add(sub2);

    //etat initial
    this.PatDegradeForm.get('qualite_benef')?.setValue('00');
    this.PatDegradeForm.get('rang_benef')?.setValue(1);
    this.PatDegradeForm.get('codeRegime')?.setValue('01');
  }

  private async chargerListes(): Promise<void> {
    //TODO DIC-getListeOrganismes //interogation liste caisse centre assistance saisie
    //TODO DIC-getListeCPAM
    try {
        const [regimes, qualites, codeGestions] = await Promise.all([
            this._JFSEsrv.getListeRegimes(),
            this._JFSEsrv.getListeQualites(),
            this._JFSEsrv.getListeCodeGestions()
        ]);

        // Tri par code (en supposant que chaque objet possède une propriété `code`)
        this.regimes = regimes.sort((a, b) => a.code.localeCompare(b.code));
        this.qualites = qualites.sort((a, b) => a.code.localeCompare(b.code));
        this.codegestions = codeGestions.sort((a, b) => a.code.localeCompare(b.code));

        // console.log("Toutes les données récupérées :", { regimes, statuts, couvertures });
    } catch (error) {
        console.error("Erreur lors du chargement des listes :", error);
    }
  }

  private initialiserForm(){
    this.PatDegradeForm = this._formBuilder.group({
      nom_benef: ['',{ validators: [Validators.pattern(REGEX_NAME)], updateOn: 'blur' }],
      prenom_benef: ['',{ validators: [ Validators.pattern(REGEX_NAME)], updateOn: 'blur' }],
      date_benef: ['', { validators: [Validators.required], updateOn: 'blur' }],
      rang_benef: ['', { validators: [Validators.required], updateOn: 'blur' }],
      qualite_benef: ['', { validators: [Validators.required], updateOn: 'blur' }],
      // assureGroup: this._formBuilder.group({
      //   nom_assure: ['', { validators: [Validators.pattern(REGEX_NAME)], updateOn: 'blur' }],
      //   prenom_assure: ['',{ validators: [Validators.pattern(REGEX_NAME)], updateOn: 'blur' }],
      //   date_assure: ['',{ updateOn: 'blur' }],
      //   rang_assure: ['',{ updateOn: 'blur' }]
      // },{ validators: assureFieldsValidator }),
      NIR_assure: ['',{ validators: [Validators.required, Validators.minLength(13), Validators.pattern(/^[0-9A-Z]{13}$/)], updateOn: 'blur' }],
      Cle_assure: ['', { validators: [Validators.required,Validators.minLength(2), Validators.pattern(/^[0-9]{2}$/)], updateOn: 'blur' }],
      //AMO:
      codeRegime: ['',{ validators: [Validators.required], updateOn: 'blur' }],
      codeCaisse: ['', { validators: [Validators.required,Validators.minLength(3), Validators.maxLength(3)], updateOn: 'blur' }],
      codeCentre: ['', { validators: [Validators.required,Validators.minLength(4), Validators.maxLength(4)], updateOn: 'blur' }],
      codeSituation: ['', { validators: [Validators.required], updateOn: 'blur' }],
      codeGestion: ['',{ validators: [Validators.required], updateOn: 'blur' }],
      //AlsaceMoselle
      alsaceMoselle:[0],
      searchCtrl: ['']
    });

    this.PatDegradeForm.valueChanges.subscribe(() => {
      this.errorMessage = '';
      this.isError = false;
    });

    this.PatDegradeForm.get('searchCtrl')!.valueChanges.pipe(
      tap(() => { this.patientVu = false; }),
      filter((v: any): v is string => typeof v === 'string'),
      map(v => v.trim()),
      debounceTime(500),distinctUntilChanged(),
      tap(q => { this.loading = q.length >= 3; }),
      switchMap(q => {
        if (q.length < 3) {
          this.loading = false;
          this.SearchidPatient = null; // si tu veux vider la sélection
          this.SearchDonneeAMCPatient = undefined;
          return of([]);
        }
        const words = q.split(/\s+/).join(' ');
        return from(
          this.patientSrv.patientsInlineSearch(words, {
            perpage: -1,
            currentPage: 1,
            sortOrder: SortEnum.ASC,
            sortBy: 'nom'
          })
        ).pipe(
          catchError(() => of([]))
        );
      }),
      tap(() => { this.loading = false; })
    ).subscribe((results:Paginated<ResultatPatient>) => {
      // console.log('Résultats patients:', results);
      this.patientsList = results?.objects || []; // affecter à ta liste pour affichage/autocomplete
      if (this.patientsList.length && this.autoTrigger && !this.autoTrigger.panelOpen) {
        this.autoTrigger.openPanel();
      }
    });
    const localItem = localStorage.getItem('openPatients');
    if (localItem) {
      this.FiltredPatient = {
          openListId: JSON.parse(localItem) as string[],
          getArchive: false
        };
    }
  }

  public async onPatientSelected(p: any) {
    this.SearchidPatient = p?.id ?? null;
    this.SearchPatientNom = p?.nomPrenomDateNaissance ?? '';
    this.autoTrigger.closePanel();
    // REMPLISSAGE FORMULAIRE AVEC LES INFORMATIONS DISPONIBLE
    if (!this.SearchidPatient) return;
    let patientVit: PatientVitale | null = null;

    let loading = this.modalsrv.openLoading(this.viewContainerRef);
    try {
      patientVit = await this.patientSrv.getPatientVitaleByIdPatient(this.SearchidPatient);
    } catch (error) {
      console.error('Erreur lors de la recherche du patient Vitale :', error);
    } finally {
      loading.destroy();
    }
    if(!patientVit){
      this._snackbarSrv.openSnackBarWarning("Aucune donnée de carte vitale disponible pour ce patient.")
    }
    const codeCaisse = patientVit?.codeCaisse ?? p?.caisse ?? '';
    const codeCentre = patientVit?.codeCentre ?? p?.centre ?? '';
    const codeSituation = patientVit?.codeSituation ?? p?.situation ?? '01035';
    const codeGestion = patientVit?.codeGestion ?? p?.gestion ?? '00';
    const codeRegime = patientVit?.codeRegime ?? p?.regime ?? '01';
    const qualite = String(patientVit?.qualite ?? p?.qualite ?? '00').trim().padStart(2, '0');
    const rawNir = (patientVit?.immatriculation ?? p?.numSecSociale ?? '').replace(/\s+/g, '').trim();
    const { nir, cle } = this.splitNir(rawNir);
    const NIR_assure = (nir?.trim() || undefined) ?? (p?.ins?.trim() || undefined) ?? '';
    const Cle_assure = (cle?.trim() || undefined) ?? (p?.insKey?.trim() || undefined) ?? '';
    this.SearchDonneeAMCPatient = JSON.parse(patientVit?.donneeAMC ?? 'null');

    this.PatDegradeForm.patchValue(
      {
        nom_benef: patientVit?.nomVitale?.trim() || p?.nomUsage?.trim() || p?.nomNaissance?.trim() || '',
        prenom_benef: patientVit?.prenomVitale?.trim() || p?.prenomUsage?.trim() || p?.prenomNaissance?.trim() || '',
        date_benef: this.compactToFr(patientVit?.dateNaissance)?.trim() || p?.dateNaissance?.trim() || '01/01/1901',     // pour MatDatepicker: un Date ou null
        NIR_assure: NIR_assure,
        Cle_assure: Cle_assure,
        searchCtrl: '',
        rang_benef: patientVit?.rangGemellaire ?? p?.rang ?? 1,
        qualite_benef: qualite,
        codeRegime: codeRegime,
        codeCaisse: codeCaisse,
        codeCentre: codeCentre,
        codeSituation: codeSituation,
        codeGestion: codeGestion,
        //AlsaceMoselle
        alsaceMoselle: 0,
      },
      { emitEvent: false }
    );
    //affectation des listes regime/caisse/situation
    const org = this.ListeOrganismes?.find(o => o.codeCaisse===codeCaisse && o.codeCentre===codeCentre) || null;
    this.ControlOrganismes?.setValue(org, { emitEvent:false });
    this.PatDegradeForm.get('qualite_benef')?.setValue(String(qualite ?? '00'), { emitEvent:false });
    this.PatDegradeForm.get('codeRegime')?.setValue(String(codeRegime ?? '01'), { emitEvent:false });
    this.PatDegradeForm.get('codeSituation')?.setValue(String(codeSituation ?? ''), { emitEvent:false });
    this.filterCodeGestions(codeRegime);
    const v = String(codeGestion ?? '');
    if (this.filteredCodeGestions?.some(cg => String(cg.code) === v)) {
      this.PatDegradeForm.get('codeGestion')?.setValue(v, { emitEvent:false });
    }
    // this.DonneesBeneficiaire.idPatient = this.SearchidPatient!;
  }

  public async openRecents() {
    if(this.getPatientVu && this.recentPatients.length === 0){
      this.getPatientVu = false;
      this.patientVu = true;
      // alimente le panel avec les récents et l’ouvre
      const result = await this.patientSrv.patientsSearchFilters(this.FiltredPatient) as Paginated<ResultatPatient>;
      this.recentPatients = result?.objects || [];
      this.patientsList = this.recentPatients || [];
      // // focus si dispo, sinon on ouvre quand même le panel
      this.searchInput?.nativeElement?.focus();
    }else if(this.recentPatients.length > 0){
      this.patientsList = this.recentPatients;
    }

    // ouvrir/positionner le panel proprement
    Promise.resolve().then(() => {
      this.autoTrigger?.openPanel();
      this.autoTrigger?.updatePosition();
    });
  }

  public filterCodeGestions(regime: string): void {
      switch (regime) {
        case '02':
            this.filteredCodeGestions = this.codegestions.filter(cg => cg.code.includes('A'));
          break;
        case '03':
            this.filteredCodeGestions = this.codegestions.filter(cg => cg.code.includes('N'));
          break;
        case '04':
            this.filteredCodeGestions = this.codegestions.filter(cg => ['04'].includes(cg.code));
          break;
        case '05':
            this.filteredCodeGestions = this.codegestions.filter(cg => cg.code.includes('T'));
          break;
        case '07':
            this.filteredCodeGestions = this.codegestions.filter(cg => cg.code.includes('M'));
            // this.filteredCodeGestions = this.codegestions.filter(cg => ['D1', 'D2', 'D3'].includes(cg.code));
          break;
        default:
            // Exclure les codes contenant "A", "N", "04", "T", ou "M"
            this.filteredCodeGestions = this.codegestions.filter(
              cg => !cg.code.includes('A') &&
                    !cg.code.includes('N') &&
                    !['04'].includes(cg.code) &&
                    !cg.code.includes('T') &&
                    !cg.code.includes('M')
            );
          break;
      }

      // Vérifier si l'option sélectionnée est toujours valide
      const currentValue = this.PatDegradeForm.get('codeGestion')?.value;
      const isValid = this.filteredCodeGestions.some(cg => cg.code === currentValue);

      // Ajouter "00 - Valeur non connue" si elle n'est pas déjà présente
      if (!this.filteredCodeGestions.some(cg => cg.code === '00')) {
        this.filteredCodeGestions.unshift({ code: '00', libelle: 'Valeur non connue' });
      }

      // Si l'option actuelle n'est plus valide, sélectionner la première valeur dispo
      if (!isValid && this.filteredCodeGestions.length > 0) {
          this.PatDegradeForm.get('codeGestion')?.setValue(this.filteredCodeGestions[0].code);
      }
  }

  public regimeAM(checkbox:boolean){
    this.PatDegradeForm.get('alsaceMoselle')?.setValue(checkbox);
  }

  public onNirChange(nir: string) {
    if (nir.length === 13) {
      nir = nir.toUpperCase();
      // this.cle = this._JFSEsrv.calculerCleNIR(nir);
      // const cleFormattee = this.cle.toString().padStart(2, '0');
      // this.PatDegradeForm.patchValue({ Cle_assure: cleFormattee });
      this.PatDegradeForm.patchValue({ NIR_assure: nir });
    } else {
      this.cle = null;
      this.PatDegradeForm.patchValue({ Cle_assure: '' });
    }
  }

  public onCleChange(cle: string) {
    const nir = this.PatDegradeForm.get('NIR_assure')?.value.toUpperCase();
    if (cle.length === 2 && nir && nir.length === 13) {
      this.cle = this._JFSEsrv.calculerCleNIR(nir);
      const cleFormattee = this.cle.toString().padStart(2, '0');
      if (cleFormattee !== cle) {
        this.isError = true;
        this.errorMessage = 'La clé de l’assuré ne correspond pas au NIR renseigné.';
        this._snackbarSrv.openSnackBar(this.errorMessage);
        this.PatDegradeForm.patchValue({ Cle_assure: '' });
        // this.PatDegradeForm.patchValue({ NIR_assure: nir });
      }
    }
  }

  public doUppercaseInputValue(absCtrl: AbstractControl | null): void {
    if (!absCtrl || typeof absCtrl.value !== 'string') {
      return;
    }

    let value = absCtrl.value.trim();
    if (!value) return;

    const reg = /[^a-zA-Z\s'-]/g;
    value = this._strUtilsSrv.uppercaseString(this._strUtilsSrv.removeAccents(value)).replace(reg, '');

    if (value !== absCtrl.value) {
      absCtrl.setValue(value, { emitEvent: false });
      absCtrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
  }

  public formatterDateBenef(): void {
    const control = this.PatDegradeForm.get('date_benef');
    let value = control?.value;

    if (!value || typeof value !== 'string') {
      control?.setErrors({ invalidFormat: true });
      return;
    }

    // Nettoyage : supprime tout sauf les chiffres
    value = value.replace(/[^\d]/g, '');

    // On attend exactement 8 chiffres (JJMMAAAA)
    if (value.length !== 8) {
      control?.setErrors({ invalidFormat: true });
      return;
    }

    const jour = value.substring(0, 2);
    const mois = value.substring(2, 4);
    const annee = value.substring(4, 8);
    const dateFormatee = `${jour}/${mois}/${annee}`;

    if(mois > 12 ) {
      this.dateNaissBenef = 'Date lunaire *';
    }else{
      this.dateNaissBenef = 'Date de naissance *';
    }

    const formatValide = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(dateFormatee);

    if (formatValide) {
      control?.setValue(dateFormatee);
      control?.setErrors(null); // ✅ tout bon
    } else {
      control?.setErrors({ invalidFormat: true }); // mauvais format
    }
  }

  public onSelectedOrganisme(event: any): void {
    this.PatDegradeForm.patchValue({ codeCaisse: event.codeCaisse });
    this.PatDegradeForm.patchValue({ codeCentre: event.codeCentre });
  }

  // Permet d'afficher dans le champ le libellé souhaité
  public displayOrganismes(item: any): string {
    const Organismes = `${item.nomCaisse}
    ${item.adresse1} ${item.adresse2}
    ${item.codePostal} ${item.commune} ${item.cedex ? `cedex ${item.cedex}` : ''}
    ${item.telephone}`.trim();

    return item ? `${Organismes}`: '';
  }

  public onSubmitCouverture(): void {
    if (this.PatDegradeForm.valid) {
      const rawDate: string = this.PatDegradeForm.value.date_benef; // ex: "01/12/2025"
      const parts = rawDate.split('/'); // ["01", "12", "2025"]
      const formattedDate = parts.length === 3 ? `${parts[2]}${parts[1]}${parts[0]}` : null; // Format: "YYYYMMDD"

      this.PatDegradeForm.value.date_benef = formattedDate;

      if(this.PatDegradeForm.value.date_assure){
        const rawDate: string = this.PatDegradeForm.value.date_assure; // ex: "01/12/2025"
        const parts = rawDate.split('/'); // ["01", "12", "2025"]
        const formattedDate2 = parts.length === 3 ? `${parts[2]}${parts[1]}${parts[0]}` : null;// Format: "YYYYMMDD"
        this.PatDegradeForm.value.date_assure = formattedDate2;
      }
      console.log("PatDegradeForm value:", this.PatDegradeForm.value);
      const formValueWithAMO = {
        ...this.PatDegradeForm.value,
        idPatient: this.SearchidPatient ?? '',
        immatriculation:this.PatDegradeForm.value.NIR_assure+this.PatDegradeForm.value.Cle_assure,
        dateNaissance: this.PatDegradeForm.value.date_benef,
        qualite: this.PatDegradeForm.value.qualite_benef,
        rangGemellaire: this.PatDegradeForm.value.rang_benef.toString(),
        nom: this.PatDegradeForm.value.nom_benef,
        prenom: this.PatDegradeForm.value.prenom_benef,
        nomUsuel: this.PatDegradeForm.value.nom_benef,
        libelleQualite: this.qualites.find(q => q.code === this.PatDegradeForm.value.qualite_benef)?.libelle,
        AMO: {
          codeRegime: this.PatDegradeForm.value.codeRegime,
          codeCaisse: this.PatDegradeForm.value.codeCaisse,
          codeCentre: this.PatDegradeForm.value.codeCentre,
          codeGestion: this.PatDegradeForm.value.codeGestion,
          codeSituation: this.PatDegradeForm.value.codeSituation,
          codeCouverture: this.PatDegradeForm.value.codeCouverture ? this.PatDegradeForm.value.codeCouverture : ''
        },
        donneeAMC: this.SearchDonneeAMCPatient ?? undefined,
      };

      this.dialogRef.close(formValueWithAMO); // Ferme le dialogue en envoyant les données
    } else {
      this.errorMessage = "Veuillez remplir tous les champs obligatoires.";
      this._snackbarSrv.openSnackBar(this.errorMessage);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  /** "DD/MM/YYYY" -> "YYYYMMDD" (ex: "01/12/2025" -> "20251201") */
  private frToCompact(dateFr: string): string | null {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((dateFr || '').trim());
    if (!m) return null;
    const [_, dd, mm, yyyy] = m;
    return `${yyyy}${mm}${dd}`;
  }

  /** "YYYYMMDD" -> "DD/MM/YYYY" (ex: "20251201" -> "01/12/2025") */
  private compactToFr(yyyymmdd: string): string | null {
    const s = (yyyymmdd || '').trim();
    if (!/^\d{8}$/.test(s)) return null;
    const yyyy = s.slice(0, 4), mm = s.slice(4, 6), dd = s.slice(6, 8);
    return `${dd}/${mm}/${yyyy}`;
  }

  private splitNir(immatriculation: string) {
    const raw = (immatriculation ?? '').toUpperCase().trim();

    let nir = '';
    let cle = '';

    if (immatriculation && immatriculation.length === 15) {
      nir = immatriculation.slice(0, 13);
      cle = immatriculation.slice(13, 15);
    }

    return { nir, cle };
  }
}
